import { useNetInfo } from '@react-native-community/netinfo';

export function useNetState() {
  const { isConnected } = useNetInfo();
  return {
    isNetworkAvailable: isConnected,
  };
}
